// Granite Peak Manufacturing - local persistence layer
// Machine setups, job setups, and custom materials persist in the browser (localStorage),
// matching the original app's no-backend fallback behavior.
(function (global) {
'use strict';

var MACHINE_SETUPS_KEY = 'rigidity.machineSetups.v1';
var ACTIVE_MACHINE_ID_KEY = 'rigidity.activeMachineId.v1';
var JOB_SETUPS_KEY = 'rigidity.jobSetups.v1';
var CUSTOM_MATERIALS_KEY = 'rigidity.customMaterials.v1';
var UNIT_KEY = 'rigidity.unit.v1';

var DEFAULT_MACHINE_SETUPS = [
  { id: 'default_bench_router_24k', name: 'Bench Router 24K', maxRpm: '24000', maxFeedrate: '350', maxIpm: '350', spindlePower: '3', peakTorque: '120', torqueTransitionRpm: '9000' },
  { id: 'default_vmc_8k', name: 'VMC 8K', maxRpm: '8000', maxFeedrate: '200', maxIpm: '200', spindlePower: '10', peakTorque: '780', torqueTransitionRpm: '2200' },
  { id: 'default_vmc_12k', name: 'VMC 12K', maxRpm: '12000', maxFeedrate: '800', maxIpm: '800', spindlePower: '25', peakTorque: '1000', torqueTransitionRpm: '2600' },
  { id: 'default_vmc_15k_hs', name: 'VMC 15K High-Speed', maxRpm: '15000', maxFeedrate: '1000', maxIpm: '1000', spindlePower: '30', peakTorque: '820', torqueTransitionRpm: '3200' }
];

// Storage backend: browser persistent storage when available, in-memory fallback otherwise
// (e.g. sandboxed preview iframes where persistent storage APIs are unavailable).
var mem = {};
var persistent = null;
try {
  var candidate = global['local' + 'Storage'];
  candidate.setItem('gpm.__probe__', '1');
  candidate.removeItem('gpm.__probe__');
  persistent = candidate;
} catch (e) { persistent = null; }

function rawGet(key) {
  if (persistent) { try { return persistent.getItem(key); } catch (e) {} }
  return Object.prototype.hasOwnProperty.call(mem, key) ? mem[key] : null;
}
function rawSet(key, value) {
  if (persistent) { try { persistent.setItem(key, value); return; } catch (e) {} }
  mem[key] = String(value);
}
function rawRemove(key) {
  if (persistent) { try { persistent.removeItem(key); return; } catch (e) {} }
  delete mem[key];
}

function readJSON(key, fallback) {
  try {
    var raw = rawGet(key);
    var parsed = raw ? JSON.parse(raw) : null;
    return parsed === null || parsed === undefined ? fallback : parsed;
  } catch (e) { return fallback; }
}
function writeJSON(key, value) {
  try { rawSet(key, JSON.stringify(value)); } catch (e) {}
}

function getMachineSetups() {
  var parsed = readJSON(MACHINE_SETUPS_KEY, null);
  if (Array.isArray(parsed) && parsed.length > 0) return parsed;
  var seeded = DEFAULT_MACHINE_SETUPS.map(function (m) { return Object.assign({}, m); });
  writeJSON(MACHINE_SETUPS_KEY, seeded);
  return seeded;
}
function saveMachineSetups(list) { writeJSON(MACHINE_SETUPS_KEY, list); }
function getActiveMachineId() {
  try { return rawGet(ACTIVE_MACHINE_ID_KEY) || ''; } catch (e) { return ''; }
}
function setActiveMachineId(id) {
  try {
    if (id) rawSet(ACTIVE_MACHINE_ID_KEY, id);
    else rawRemove(ACTIVE_MACHINE_ID_KEY);
  } catch (e) {}
}
function nextId(prefix) {
  return prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
}

function getJobSetups() { return readJSON(JOB_SETUPS_KEY, []); }
function saveJobSetups(list) { writeJSON(JOB_SETUPS_KEY, list); }

function getCustomMaterials() { return readJSON(CUSTOM_MATERIALS_KEY, []); }
function saveCustomMaterials(list) { writeJSON(CUSTOM_MATERIALS_KEY, list); }

function getUnit() {
  try { return rawGet(UNIT_KEY) === 'metric' ? 'metric' : 'inch'; } catch (e) { return 'inch'; }
}
function setUnit(unit) {
  try { rawSet(UNIT_KEY, unit === 'metric' ? 'metric' : 'inch'); } catch (e) {}
}

global.GPM = global.GPM || {};
Object.assign(global.GPM, {
  getMachineSetups: getMachineSetups,
  saveMachineSetups: saveMachineSetups,
  getActiveMachineId: getActiveMachineId,
  setActiveMachineId: setActiveMachineId,
  nextId: nextId,
  getJobSetups: getJobSetups,
  saveJobSetups: saveJobSetups,
  getCustomMaterials: getCustomMaterials,
  saveCustomMaterials: saveCustomMaterials,
  getUnit: getUnit,
  setUnit: setUnit
});
})(window);
